module.exports = __webpack_public_path__ + "static/media/right.362c171c.svg";